import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-s3-config',
  templateUrl: './integration-s3-config.component.html',
  styleUrls: ['./integration-s3-config.component.css'],
})
export class IntegrationS3ConfigComponent implements OnInit {
  @Input() settingsForm: FormGroup;
  @Input() settings: any;

  public fields = [
    {'id': 'accessKeyId', 'name': 'Access Key ID', type: 'password'},
    {'id': 'accessKey', 'name': 'Access Key', type: 'password'},
    {'id': 'region', 'name': 'Region'},
    {'id': 'bucketName', 'name': 'Bucket Name'},
    {'id': 'path', 'name': 'Path'}
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    for(var field of this.fields) {
      this.settingsForm.addControl(
        field.id,
        this.fb.control('', Validators.required)
      );
    }

    this.settingsForm.patchValue(this.settings);
  }
}
